import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { UserPortal } from '@/common/types/auth.types';

const baseURL = 'https://portal.palmettoeoc.com/prod/public/api/cognito/account';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  endpoints: (builder) => ({
    verifyToken: builder.query<UserPortal, string>({
      query: (token) => ({
        url: '',
        headers: { Authorization: token },
      }),
    }),
  }),
});

export const { useLazyVerifyTokenQuery } = authApi;
